import { STATIC_DISPLAY_KEYS, STATIC_KEYS } from 'src/app/shared/shared-config';

export const FILTER_KEYS = {
  REGION: 'regions',
  CHANNEL: 'channels',
};

export const EDIT = 'edit';

export const NEW = 'new';
export const STATIC_DATA = {
  OUTPUT_FILTERS: [
    {
      displayName: 'Retailer',
      name: 'retailer',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'channel',
      options: [],
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: false,
      isMandatory: false,
      mandatorySymbolPosition: 'left',
      optionAllPresent: true,
      filterMarginBottom: 20,
    },
    {
      displayName: 'Manufacturer',
      name: 'Manufacturer',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'channel',
      options: [],
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: false,
      isMandatory: false,
      mandatorySymbolPosition: 'left',
      optionAllPresent: true,
      filterMarginBottom: 20,
    },
    {
      name: 'PriceSector',
      displayName: 'Price Sector',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'category',
      configKey2: 'category',
      payloadKey: 'category',
      options: [],
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: false,
      isMandatory: false,
      mandatorySymbolPosition: 'left',
      filterMarginBottom: 20,
    },
    {
      name: 'BrandHouse',
      displayName: 'Brand',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'BrandHouse',
      filterKey: 'brand',
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: true,
      menuWidth: 220,
      filterMarginBottom: 13,
    },
    {
      name: 'BrandVariant_x',
      displayName: 'Sub Brand',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'BrandVariant_x',
      filterKey: 'BrandVariant_x',
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: true,
      menuWidth: 220,
      filterMarginBottom: 13,
    },
    {
      name: 'BrandPackVariant',
      displayName: 'SKU Description',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'sub_channel',
      options: [],
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: false,
      isMandatory: false,
      mandatorySymbolPosition: 'left',
      filterMarginBottom: 20,
    },
    {
      displayName: 'Pack Size',
      name: 'PackContents',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'channel',
      options: [],
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: false,
      isMandatory: false,
      mandatorySymbolPosition: 'left',
      optionAllPresent: true,
      filterMarginBottom: 20,
    },
    {
      displayName: 'Pack Size Bucket',
      name: 'LengthBand',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'channel',
      options: [],
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: false,
      isMandatory: false,
      mandatorySymbolPosition: 'left',
      optionAllPresent: true,
      filterMarginBottom: 20,
    },
    {
      name: 'TarLevel',
      displayName: 'Flavor',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'Brand',
      filterKey: 'brand',
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: true,
      menuWidth: 220,
      filterMarginBottom: 13,
    },
    // {
    //   displayName: 'Category',
    //   name: 'Category',
    //   filters: [],
    //   selectedFilters: [],
    //   filterIcon: 'keyboard_arrow_down',
    //   configKey: 'month',
    //   options: [],
    //   enableSearch: true,
    //   isSingleSelection: false,
    //   showRadioBtnForSingleSelection: false,
    //   isMandatory: false,
    //   mandatorySymbolPosition: 'left',
    //   optionAllPresent: true,
    //   filterMarginBottom: 20,
    // },

    // {
    //   name: 'BrandHouse',
    //   displayName: 'BrandHouse',
    //   filters: [],
    //   selectedFilters: [],
    //   filterIcon: 'keyboard_arrow_down',
    //   configKey: 'brand',
    //   configKey2: 'brand',
    //   payloadKey: 'brand',
    //   options: [],
    //   enableSearch: true,
    //   isSingleSelection: false,
    //   showRadioBtnForSingleSelection: false,
    //   isMandatory: false,
    //   mandatorySymbolPosition: 'left',
    //   filterMarginBottom: 20,
    // },
    // {
    //   name: 'ppg',
    //   displayName: 'PPG',
    //   filters: [],
    //   selectedFilters: [],
    //   filterIcon: 'keyboard_arrow_down',
    //   configKey: 'ppg',
    //   configKey2: 'ppg',
    //   payloadKey: 'ppg',
    //   options: [],
    //   enableSearch: true,
    //   isSingleSelection: false,
    //   showRadioBtnForSingleSelection: false,
    //   isMandatory: false,
    //   filterMarginBottom: 20,
    //   mandatorySymbolPosition: 'left',
    // },
    // {
    //   name: 'mc_pricing',
    //   displayName: 'MC Pricing',
    //   filters: [],
    //   selectedFilters: [],
    //   filterIcon: 'keyboard_arrow_down',
    //   configKey: 'mc_pricing',
    //   configKey2: 'mc_pricing',
    //   payloadKey: 'mc_pricing',
    //   options: [],
    //   enableSearch: true,
    //   isSingleSelection: false,
    //   showRadioBtnForSingleSelection: false,
    //   isMandatory: false,
    //   mandatorySymbolPosition: 'left',
    // },
    // {
    //   name: 'SKU',
    //   filters: [],
    //   selectedFilters: [],
    //   filterIcon: 'keyboard_arrow_down',
    //   configKey: 'sku',
    //   configKey2: 'SKU',
    //   payloadKey: 'sku',
    // },
  ],
  OUTPUT_SCENARIO_FILTERS: [
    {
      displayName: 'Select Child Scenario',
      name: 'child_scenario',
      filters: [],
      selectedFilters: [],
      filterIcon: 'keyboard_arrow_down',
      configKey: 'channel',
      options: [],
      enableSearch: true,
      isSingleSelection: false,
      showRadioBtnForSingleSelection: false,
      isMandatory: false,
      mandatorySymbolPosition: 'left',
      optionAllPresent: false,
      filterMarginBottom: 20,
    },
  ],
};

export const FAILED = 'Failed';
export const COMPLETED = 'Completed';
export const PROCESSING = 'Processing';
export const DRAFT = 'Draft';

export const ABS_OR_PERCENT = false;
export const MT_PLUS_BODEGAS = 'MT AUTOS + BODEGAS';
export const MT_PLUS_BODEGAS_MAP = 'MT AUTOS AND BODEGAS';

export const JUGOS = 'JUGOS + NECTARES';
export const JUGOS_MAP = 'JUGOS AND NECTARES';

export const SCENARIO_LIBRARY_LIMIT = 20;
export const BASE_SEPERATOR = '__base_data__';
export const OUTPUT_LIMIT = 7;
export const NA = 'NA';

export const ABBREVIATE_NUMBER = (num, fixed) => {
  // if (num < 1000) {
  //   return num.toFixed(fixed);
  // }

  // const suffixes = ['', 'K', 'M', 'B', 'T'];
  // let index = 0;

  // while (num >= 1000 && index < suffixes.length - 1) {
  //   num /= 1000.0;
  //   index++;
  // }

  // const formattedNum = num.toFixed(fixed) + suffixes[index];
  // return formattedNum;

  const isNegative = num < 0;
  num = Math.abs(num);

  if (num < 1000) {
    const formattedNum = num.toFixed(fixed);
    return isNegative ? `-${formattedNum}` : formattedNum;
  }

  const suffixes = ['', 'K', 'M', 'B', 'T'];
  let index = 0;

  while (num >= 1000 && index < suffixes.length - 1) {
    num /= 1000.0;
    index++;
  }

  const formattedNum = num.toFixed(fixed) + suffixes[index];
  return isNegative ? `-${formattedNum}` : formattedNum;
};

export const CHILD_SCENARIO_PAGE_LIMIT = 100;

export const FRONTEND_REF_ID = 'frotendId';
export const PERCENT_SEPERATOR = '__percent_increment__';
export const ABSOLUTE_SEPERATOR = '__absolute_increment__';
export const INFLATION_SEPERATOR = '__inflation__';

export const USER_INFO = 'user_info';

export const OUTPUT_SEPERATOR = '*____*';

export const OUTPUT_IDENTIFIER = 'originalVal';
